import type { FontFamilyType } from '~/interfaces/font_family';

const normalizeFontType = (fontType: string): FontFamilyType | string => {
  if (!fontType) return '';

  return fontType.toLowerCase().split(' ').join('-') as FontFamilyType;
};

export default normalizeFontType;
